import { render, staticRenderFns } from "./WaveyMenu.vue?vue&type=template&id=f0fb9266&scoped=true&lang=pug&"
import script from "./WaveyMenu.vue?vue&type=script&lang=js&"
export * from "./WaveyMenu.vue?vue&type=script&lang=js&"
import style0 from "./WaveyMenu.vue?vue&type=style&index=0&id=f0fb9266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb9266",
  null
  
)

export default component.exports